import React from "react";
import styled from "styled-components";
import cncBackgroundImage from "images/background-cnc.jpg";
import { Visibility } from "semantic-ui-react";

const CNCHero = styled.div`
  background-image: url('${cncBackgroundImage}');
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;

  @media screen and (max-width: 768px) {
    background-position: center;
  }

`;
const TransparencyHero = styled.div`
  background-color: rgba(54, 54, 54, 0.8) !important;
`;

const CNCFeature = () => (
  <CNCHero className="hero is-fullheight is-dark">
    <div className="columns">
      <div className="column is-two-fifths-widescreen is-four-fifths-desktop is-12-touch">
        <TransparencyHero className="hero is-fullheight is-dark">
          <div className="hero-body">
            <div className="container">
              <div className="columns">
                <div className="column is-offset-1 is-10">
                  <h1 className="title is-1">Precision CNC</h1>
                  <h2 className="subtitle is-4">
                    The Next Generation of Machining
                  </h2>
                  <hr />
                  <p>
                    We've been in the CNC game as long as it's been played, and
                    we know a good thing when we see it. Accratronics is leading
                    the vanguard in adoption of next-generation CNC technology,
                    bringing in a fleet of hyperpowered multi-spindle,
                    multi-axis turning centers that singularly outperform
                    traditional machining cells.
                    <br />
                    <br />
                    For the last half-century, we've been perfecting the craft
                    of precision machining, adapting alongside new technologies,
                    and the ever-increasing needs of the most demanding
                    industries there are—on and off earth.
                    <br />
                    <br />
                    We take the toughest materials around, from exotic
                    superalloys like Inconel and Nitronic, to good ol' American
                    Steel, and turn them into works of art.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </TransparencyHero>
      </div>
    </div>
  </CNCHero>
);

const Cnc = props => (
  <div>
    <Visibility
      onBottomPassed={props.onBottomPassed}
      onBottomPassedReverse={props.onBottomPassedReverse}
      once={false}
    >
      <CNCFeature />
    </Visibility>
  </div>
);
export default Cnc;



// WEBPACK FOOTER //
// ./src/pages/Cnc/Cnc.js